/**
 * Types and interfaces for Firebase Remote Config and Platform Feature Toggles.
 */

/**
 * Represents a single parameter/feature flag in Remote Config.
 */
export interface IRemoteConfigParameterItem {
  /** Unique parameter key name, e.g. "enable_collaborative_editor". */
  key: string;
  /** Current evaluated value. */
  value: boolean | string | number;
  /** Fallback baseline default value. */
  defaultValue: boolean | string | number;
  /** Human-readable explanation of what this flag controls. */
  description?: string;
  /** Provenance of the current value. */
  source: "remote" | "default" | "override";
  /** Optional last update timestamp. */
  updatedAt?: number;
}

/**
 * Request payload for getRemoteConfigTemplateFunc.
 */
export interface IGetRemoteConfigTemplateRequest {}

/**
 * Response payload for getRemoteConfigTemplateFunc.
 */
export interface IGetRemoteConfigTemplateResponse {
  /** Indicates whether the operation succeeded. */
  status: boolean;
  /** Map of parameter keys to parameter details. */
  parameters: Record<string, IRemoteConfigParameterItem>;
  /** Optional Remote Config template version number or ETag. */
  version?: string;
  /** Error message if retrieval failed. */
  error?: string;
}

/**
 * Request payload for updateRemoteConfigParameterFunc.
 */
export interface IUpdateRemoteConfigParameterRequest {
  /** The parameter key to update or create. */
  key: string;
  /** The new boolean, string, or number value. */
  value: boolean | string | number;
  /** Optional description for the parameter. */
  description?: string;
}

/**
 * Response payload for updateRemoteConfigParameterFunc.
 */
export interface IUpdateRemoteConfigParameterResponse {
  /** Indicates whether the update succeeded. */
  status: boolean;
  /** Informational message regarding the update. */
  message?: string;
  /** The resulting updated parameter item. */
  updatedParameter?: IRemoteConfigParameterItem;
  /** Error message if the update failed. */
  error?: string;
}
